// METIS Hub wording — namespace "logs" (en), 369 keys.
// Extracted once from the approved mockup (poc-plan/mockup-src: js/screens/logs.js App.addI18n).
// From now on this file is the source: edit it by hand (keep ko/en keys in pairs — packages/i18n tests check
// key parity, Hangul in English text and the plan 9.1.3 wording rules). Placeholders: {name}, plural {n|one|other}.
const logs: Record<string, string> = {
  "logs.kicker.me": "My records",
  "logs.kicker.team": "My team · {team}",
  "logs.kicker.all": "Whole company",
  "logs.kicker.allTeam": "All · {team} only",
  "logs.desc": "{range} · Korea time · as of {asof}",
  "logs.search.label": "Find records",
  "logs.search.ph.me": "Question text, file name or #number",
  "logs.search.ph.wide": "#number · your text",
  "logs.search.hint.me": "Search: find your records by question text, file name or conversation number.",
  "logs.search.hint.wide": "Search: other people’s records can only be found by conversation number. Text and file-name search works on your own records only.",
  "logs.cond.title": "Filters",
  "logs.cond.button": "Filters",
  "logs.cond.buttonN": "Filters {n}",
  "logs.cond.sheet": "Choose filters",
  "logs.cond.clear": "Clear filters",
  "logs.cond.apply": "Apply",
  "logs.cond.q": "search {q}",
  "logs.cond.applied": "Filters applied",
  "logs.cond.cleared": "All filters cleared",
  "logs.f.method": "How used",
  "logs.f.tool": "Tool",
  "logs.f.model": "AI model",
  "logs.f.surface": "Where it ran",
  "logs.f.person": "Person",
  "logs.f.any": "All",
  "logs.f.na": "No records match this filter",
  "logs.f.periodHint": "Change the period with the period picker above.",
  "logs.f.periodTeamHint": "Change the period with the period picker above, and the team next to the view scope in the header.",
  "logs.f.team": "Team",
  "logs.list.q": "What conversations did I have?",
  "logs.list.q.team": "What conversations did my team have?",
  "logs.list.q.all": "What conversations happened across the company?",
  "logs.list.tech": "{n|conversation|conversations} · newest first · open one for details",
  "logs.list.sum": "{period}: {n|conversation|conversations} with {p|question|questions} (usage {tok}).",
  "logs.list.selfOnlyTitle": "Only your own conversations are listed here",
  "logs.list.selfOnlyGo": "Open Insights",
  "logs.list.selfOnly": "Your current role ({role}) can’t open other people’s conversation lists. See company and team numbers in Insights.",
  "logs.list.range": "{from}–{to} of {n}",
  "logs.list.viewed": "Viewed",
  "logs.list.viewedTip": "Someone else viewed the text of this conversation",
  "logs.list.gw": "{n|CLI call|CLI calls} via the gateway · duplicate check in progress — not in the list or totals until we know the PC’s own records don’t include the same call. If they don’t, the calls appear after about 10 minutes; calls we can’t confirm stay out so nothing is counted twice.",
  "logs.col.when": "Time",
  "logs.col.person": "Person",
  "logs.col.tool": "Tool",
  "logs.col.title": "Title",
  "logs.empty.what": "No conversation records in this period.",
  "logs.empty.next": "Check connections",
  "logs.nores.title": "No conversations match these filters",
  "logs.nores.desc": "Try removing one filter.",
  "logs.nores.drop": "Remove “{label}” to see {n}",
  "logs.nores.period": "Widen to 90 days to see {n}",
  "logs.nores.clear": "Clear all filters",
  "logs.pager": "Conversation list pages",
  "logs.export": "Export",
  "logs.export.kicker": "Export · pseudonymous · no text",
  "logs.export.title": "Export the conversation list?",
  "logs.export.desc": "Exports {n|conversation|conversations} matching the current filters as CSV. Names become pseudonyms and question/answer text is left out.",
  "logs.export.cols": "Columns: conversation # · time · person (pseudonym) · tool · questions · usage · time the chat was open · recording level",
  "logs.export.head": "File header (CSV)",
  "logs.export.scope": "Only {n} within your export permission ({scope}) are included (of {m} listed).",
  "logs.export.go": "Export",
  "logs.export.done": "Export recorded (mockup: no file is created)",
  "logs.export.h1": "Exported by role: {role} · Filters: {cond}",
  "logs.export.h2": "Prohibited use: never for evaluating work or performance · Masking limits: automatic masking can’t catch every piece of personal data",
  "logs.detail.page": "Record details",
  "logs.detail.q": "What happened in this conversation?",
  "logs.detail.kicker": "Record details",
  "logs.detail.kickerNo": "Record details · Conversation #{no}",
  "logs.crumb.no": "Conversation #{no}",
  "logs.nf.title": "We can’t find this record",
  "logs.nf.desc": "Check the address. Records outside what you can see look the same.",
  "logs.nf.back": "Back to Activity",
  "logs.band.label": "Conversation summary",
  "logs.band.person": "Person",
  "logs.band.tool": "Tool",
  "logs.band.when": "Time",
  "logs.band.prompts": "Questions",
  "logs.band.calls": "Calls",
  "logs.band.modelMore": "{model} + {n} more",
  "logs.band.me": "(me)",
  "logs.badge.auth": "Billing: {v}",
  "logs.badge.authClaude": "Last method confirmed on this device (checked {time})",
  "logs.badge.authNone": "Not confirmed yet",
  "logs.badge.authReq": "Confirmed on every request",
  "logs.badge.tamperOk": "Tamper check ✓",
  "logs.badge.tamperOkTip": "Unchanged since received (hash chain · external anchor {date} matches)",
  "logs.badge.tamperBad": "Possible tampering",
  "logs.badge.tamperDemoTip": "Mockup-only demo (access & change log #{seq}). Run [Check now] in the access & change log to return to normal.",
  "logs.badge.hold": "Legal hold",
  "logs.badge.holdTip": "Kept as investigation evidence, so it isn’t deleted when retention ends",
  "logs.badge.expired": "Text retention ended",
  "logs.badge.expiredTip": "Text is kept 30 days. Usage and basic info stay 180 days.",
  "logs.badge.checking": "Support being checked · {v}",
  "logs.badge.old": "Below supported version · {v}",
  "logs.more.label": "Record details menu",
  "logs.more.raw": "Technical details",
  "logs.more.rawDesc": "Raw structure (JSON) filtered by your permissions",
  "logs.more.copy": "Copy link",
  "logs.more.copyDesc": "Re-checked against the recipient’s permissions",
  "logs.more.prev": "Previous record",
  "logs.more.next": "Next record",
  "logs.more.none": "None",
  "logs.copied": "Link copied",
  "logs.raw.kicker": "Technical details · Conversation #{no}",
  "logs.raw.title": "Structure of the received record",
  "logs.raw.desc": "Shows the retained record structure. Uncollected fields and text outside your current permissions are omitted.",
  "logs.raw.hidden": "(masked · permission needed)",
  "logs.raw.hiddenReason": "(masked · leave a reason to view)",
  "logs.raw.none": "(no record · {reason})",
  "logs.raw.note": "Actual API bodies are not collected by default.",
  "logs.raw.hash": "hash ",
  "logs.tab.label": "Record detail views",
  "logs.tab.qa": "Questions & answers",
  "logs.tab.usage": "Usage & time",
  "logs.tab.actions": "Actions by AI",
  "logs.tab.files": "Files & changes",
  "logs.tab.timeline": "Sequence",
  "logs.tab.na": "Not applicable to this usage method",
  "logs.viewed.title": "Someone else viewed the text of this conversation {n|time|times}",
  "logs.viewed.desc": "Latest: {role} · {time} · reason category: {cat}",
  "logs.viewed.go": "Who viewed my records",
  "logs.grant.title": "Access granted",
  "logs.grant.note": "This conversation only · your access is shown to the owner",
  "logs.qa.q": "What questions and answers were exchanged?",
  "logs.qa.tech": "{p|question|questions} · {a|AI answer|AI answers} · question & answer text",
  "logs.qa.tech.api": "{p|call|calls} · last question and answer of each call",
  "logs.qa.techLocked": "{p|question|questions} · question & answer text",
  "logs.qa.techLocked.api": "{p|call|calls} · question & answer text",
  "logs.qa.sum": "{p|question|questions} and {a|AI answer|AI answers} are kept.",
  "logs.qa.sum.noA": "{p|question is|questions are} kept. AI answer text was not kept ({reason}).",
  "logs.qa.sum.api": "The last question and answer of {p|call|calls} are kept.",
  "logs.qa.sum.locked": "The text of this conversation is stored, but you can’t see it right now.",
  "logs.qa.sum.none": "There’s no question text you can see in this conversation.",
  "logs.qa.qLabel": "Question {n}",
  "logs.qa.callLabel": "Call {n}",
  "logs.qa.aLabel": "AI answer",
  "logs.qa.chars": "{n} chars",
  "logs.qa.slash": "/command",
  "logs.qa.refused": "The AI refused to answer under its policy",
  "logs.qa.thinking": "The AI’s intermediate thinking is never stored.",
  "logs.qa.redact": "▇ marks parts masked before storing.",
  "logs.qa.more": "Show {n} more",
  "logs.qa.empty": "No questions or answers you can see.",
  "logs.contentSearch.label": "Find text in this conversation",
  "logs.contentSearch.go": "Find",
  "logs.contentSearch.clear": "Clear search",
  "logs.contentSearch.loading": "Searching…",
  "logs.contentSearch.count": "Found in {n} questions and answers.",
  "logs.contentSearch.truncated": "Showing the first 100. Use a more specific search.",
  "logs.contentSearch.prompt": "Question {n}",
  "logs.contentSearch.answer": "Answer {n}",
  "logs.export.kind": "Export contents",
  "logs.export.kind.rows": "Rows (pseudonyms, no text)",
  "logs.export.kind.identity": "Rows and real names",
  "logs.export.kind.content": "Rows and questions/answers (pseudonyms)",
  "logs.export.format": "File format",
  "logs.export.previewSafe": "The preview only shows pseudonymous rows.",
  "logs.export.reasonRequired": "Choose a reason category and enter at least 10 characters.",
  "logs.export.grantRequired": "First obtain viewing permission in each conversation to export someone else’s text. No file is created if a required grant is missing or expired.",
  "logs.export.doneJson": "Downloaded the JSON file. The export was recorded.",
  "logs.read.size": "Text size",
  "logs.read.s": "Small",
  "logs.read.m": "Normal",
  "logs.read.l": "Large",
  "logs.read.wrap": "Wrap long lines",
  "logs.lock.mgr.title": "Managers can’t see teammates’ text by default",
  "logs.lock.mgr.desc": "You see the team’s basic info and usage only. Turning it on needs an admin setting and a second approval.",
  "logs.lock.meta.title": "This role sees basic info only",
  "logs.lock.meta.desc": "You can’t open question/answer text or work details. Check basic info and the access & change log instead.",
  "logs.lock.perm.title": "Your role can’t see this",
  "logs.lock.perm.desc": "You don’t have permission to see this conversation’s text. Ask an admin if you need it.",
  "logs.lock.level": "This conversation was recorded at {level}, so this wasn’t kept.",
  "logs.lock.expired": "Text is kept for 30 days. Usage and basic info stay for 180 days.",
  "logs.lock.old": "Sent by a CLI older than the supported version, so text and work details weren’t accepted.",
  "logs.lock.notSent": "The CLI settings didn’t send this value. Get the settings again under Connect.",
  "logs.lock.denied": "Your latest access request was denied · {time}",
  "logs.lock.deniedWhy": "The reason was shorter than 10 characters. Denials are kept in the access & change log too.",
  "logs.lock.flow": "If you open it, you can see only this conversation for {min} minutes, and it appears in the owner’s “Who viewed my records”.",
  "logs.lock.saved": "The text is stored · {n} chars",
  "logs.use.q": "How is the usage split?",
  "logs.use.tech": "4 kinds of usage (tokens) · 100% bar · thinking is included in written by AI",
  "logs.use.tech3": "3 kinds of usage (tokens) · 100% bar · thinking is included in written by AI",
  "logs.use.sum": "Of {tok} in total, “{kind}” is the largest ({p}).",
  "logs.use.total": "Total",
  "logs.use.totalEq": "Same as the per-request table total and the summary band",
  "logs.use.reasoningNote": "Already inside written by AI, so it isn’t added to the total.",
  "logs.use.cwNote": "Not stacked in the bar or total until we confirm whether it’s inside the input.",
  "logs.use.failed": "The {n|failed request|failed requests} contribute to usage when it was received. Missing usage is not counted as zero.",
  "logs.use.bar": "Share of the 4 usage kinds",
  "logs.use.col.kind": "Kind",
  "logs.use.col.share": "Share",
  "logs.use.empty": "No successful AI requests in this conversation.",
  "logs.cost.q": "What is the estimated cost?",
  "logs.cost.tech": "Estimated cost · {kind} · not a bill",
  "logs.cost.sum": "{usd} by {kind}.",
  "logs.cost.kind": "Cost kind",
  "logs.time.q": "How long did it take?",
  "logs.time.tech": "AI active time · time the chat was open · wait time",
  "logs.time.sum": "AI answers took {a} typically and {b} when slow.",
  "logs.time.waitV": "Typical {a} · slow {b}",
  "logs.time.ttft": "Time to first character (typical)",
  "logs.model.q": "Which AI models and thinking depth were used?",
  "logs.model.tech": "{n|AI model|AI models} · requests · usage",
  "logs.model.sum": "{model} handled the most requests ({n}).",
  "logs.model.req": "{n|request|requests}",
  "logs.model.bg": "incl. {n|background request|background requests}",
  "logs.req.q": "What does each request look like?",
  "logs.req.q.api": "What does each call look like?",
  "logs.req.tech": "{n|AI request|AI requests} · in time order · total = bar above",
  "logs.req.sum": "The longest wait was request {n} ({d}).",
  "logs.req.col.no": "No.",
  "logs.req.col.when": "Time",
  "logs.req.col.usage": "Usage",
  "logs.req.col.wait": "Wait",
  "logs.req.col.result": "Result",
  "logs.req.ok": "Succeeded",
  "logs.req.retryOk": "Succeeded on retry",
  "logs.req.bg": "Background",
  "logs.req.bgTip": "A light background request, such as making a title",
  "logs.req.more": "Show {n} more",
  "logs.req.title": "Request {n}",
  "logs.req.titleApi": "Call {n}",
  "logs.req.successCount": "{n|successful request|successful requests}",
  "logs.req.cwHead": "verifying · not in total",
  "logs.wf.col": "Timeline",
  "logs.wf.label": "Timeline bars",
  "logs.wf.wait": "Wait (to first character)",
  "logs.wf.rest": "Rest (AI processing · receiving)",
  "logs.wf.one": "Single color (can’t split)",
  "logs.wf.fail": "Failed request",
  "logs.wf.gap": "≈ After a break of over 1 minute, the time axis starts over from that row",
  "logs.wf.after": "Starts over after a {d} break",
  "logs.wf.note": "Bars show when each request started in the conversation and how long it took. Every row uses the same scale.",
  "logs.wf.aria": "Started {when} · wait {w} · rest {r}",
  "logs.wf.ariaOne": "Started {when} · took {d}",
  "logs.wf.ariaFail": "Started {when} · failed · {d}",
  "logs.act.q": "What did the AI do?",
  "logs.act.tech": "Actions by AI · 6 kinds of other records · original event name on each line",
  "logs.act.sum": "The AI took {n|action|actions} ({c|command|commands} · {r|rejection|rejections} · {e|error or retry|errors or retries}).",
  "logs.act.sum.api": "API key calls have no actions by AI. There are {e|error or retry|errors or retries}. See the call order in the Sequence tab.",
  "logs.act.sum.apiNoErr": "API key calls have no actions by AI, and there were no errors or retries. See the call order in the Sequence tab.",
  "logs.cat.label": "Record types",
  "logs.cat.tool": "Tool runs",
  "logs.cat.command": "Commands",
  "logs.cat.decision": "Allowed / rejected",
  "logs.cat.error": "Errors & retries",
  "logs.cat.system": "Environment",
  "logs.cat.access": "Views & exports of this record",
  "logs.act.actor": "Who decided allow / reject",
  "logs.act.lockDetail": "Full commands and file paths are locked. Only action names and results are shown.",
  "logs.act.levelDetail": "Not recorded at level ④, so full commands and file paths weren’t kept.",
  "logs.act.expiredDetail": "Retention ended, so full commands and file paths were deleted.",
  "logs.act.empty": "No records of the selected types.",
  "logs.act.pager": "AI action pages",
  "logs.act.accessHidden": "Only the owner and people who can see the access & change log see who viewed this record.",
  "logs.act.view": "{who} viewed · {cat}",
  "logs.act.viewDenied": "{who} was denied · reason shorter than 10 characters",
  "logs.act.noViews": "Nobody has opened the text of this conversation yet.",
  "logs.act.locked": "Locked",
  "logs.act.na": "Not applicable to this usage method",
  "logs.files.q": "Which files did the AI open and edit?",
  "logs.files.tech": "{r|file|files} opened by AI · {e|file|files} edited",
  "logs.files.sum": "The AI touched {n|file|files} and edited {e} of them.",
  "logs.files.sumNone": "The AI didn’t touch any files in this conversation.",
  "logs.files.view": "View",
  "logs.files.list": "List",
  "logs.files.tree": "Tree",
  "logs.files.label": "Files opened or edited by AI",
  "logs.files.scroll": "File list · scroll up and down",
  "logs.files.op.read": "Opened",
  "logs.files.op.edit": "Edited",
  "logs.files.op.create": "Created",
  "logs.files.op.delete": "Deleted",
  "logs.files.est": "Estimated",
  "logs.files.times": "×{n}",
  "logs.files.pickHint": "Choose a file to see its changes.",
  "logs.split.handle": "File list width",
  "logs.split.tip": "Use ← → to resize and Esc to go back to the starting width",
  "logs.files.claudeNote": "Files the AI opened with shell commands (like cat) may be missing from this list.",
  "logs.files.codexNote": "Files edited by patches are counted exactly. Files opened or created by shell commands are estimated from the command text (marked estimated); when the command carries the text, the new content is shown.",
  "logs.files.labelOnly": "Only the last two path parts are shown now. Full paths and changes appear after you leave a reason.",
  "logs.files.expiredNote": "Retention ended, so full paths were deleted. Only the labels remain.",
  "logs.files.countsOnly": "You can’t see file names. Only counts are shown.",
  "logs.files.countsLine": "{r|file|files} opened · {e|file|files} edited",
  "logs.files.folder": "{name} folder",
  "logs.badge.authNote": "Same basis as billing on the CLI tool card (subscription sign-in · API key · not confirmed).",
  "logs.lock.savedDiff": "Changes are stored · {n|file|files} · +{a}/−{d} lines",
  "logs.lock.savedFiles": "The file list is stored · {n|file|files}",
  "logs.diff.metricEst": "Line count (estimated from patches)",
  "logs.req.thinkTip": "Included in “Written by AI” (not added to totals)",
  "logs.band.more": "More",
  "logs.band.less": "Less",
  "logs.del.title": "Not viewable — deletion requested",
  "logs.del.desc.pending": "A deletion request came in on {date}, so it left every list, detail and total right away. It’s handled by {due}.",
  "logs.del.desc.done": "Text and identifiers were deleted on {done} as requested. Only usage for cost settlement stays, as pseudonymous aggregates.",
  "logs.del.desc.held": "A deletion was requested but it’s on hold because of a legal hold. Viewing stays blocked.",
  "logs.del.own": "See the status in My records & settings.",
  "logs.del.other": "It was the owner’s request, so no role can open it.",
  "logs.del.mine": "See my deletion requests",
  "logs.diff.q": "What changed?",
  "logs.diff.tech": "Changes · {n|file|files} · {a} added · {d} removed",
  "logs.diff.sum": "{a|line|lines} added and {d|line|lines} removed across {n|file|files}.",
  "logs.diff.none": "No files were changed in this conversation.",
  "logs.diff.metric": "Line metric (sent by the CLI)",
  "logs.diff.metricV": "{a} added · {d} removed",
  "logs.diff.noneRec": "Changes to the {e|edited file|edited files} weren’t kept in the record.",
  "logs.diff.fewerNote": "Changes were kept for only {n} of the {e|edited file|edited files}.",
  "logs.diff.metricNote": "The CLI counts the line metric over the whole conversation, so it can be larger than the changes below.",
  "logs.diff.codexNote": "Codex sends whole patches. Line counts are counted from the patches.",
  "logs.diff.truncNote": "Only part remains. Claude Code sends the first 128 characters of each value (the original length shows as …[N chars]); very long changes can also be cut at the storage limit.",
  "logs.diff.showing": "Showing changes to {name}",
  "logs.diff.readOnly": "The AI only opened this file, so nothing changed.",
  "logs.diff.notKept": "This file was edited, but its changes weren’t kept in the record.",
  "logs.diff.deleted": "The AI deleted this file. Deleted content isn’t kept in the record.",
  "logs.tl.q": "In what order did things happen?",
  "logs.tl.tech": "Question → AI call → tool run · allow/reject → result → answer · bars show time taken",
  "logs.tl.sum": "{p|question|questions} led to {r|AI call|AI calls} and {a|action|actions}.",
  "logs.tl.sum.api": "{r|call was|calls were} sent, with {d} of waiting in total.",
  "logs.tl.sum.apiRetry": "{r|call was|calls were} sent (including {f|failed call|failed calls}), with {d} of waiting in total.",
  "logs.tl.tech.api": "Call order · bars show time taken",
  "logs.tl.turn": "Question {n}",
  "logs.tl.unlinked": "Records without a linked question",
  "logs.tl.turnSlash": "/command",
  "logs.tl.turnMeta": "{r|AI call|AI calls} · {a|action|actions} · {d}",
  "logs.tl.noCalls": "No AI calls",
  "logs.tl.metaOnly": "You can’t see the text, so only step names and times are shown.",
  "logs.tl.wait": "Wait {d} · first character {f}",
  "logs.tl.promptLen": "Question text, {n} chars",
  "logs.tl.answerLen": "AI answer",
  "logs.tl.call": "{model} · {tok}",
  "logs.tl.callNo": "Call {n} · {model} · {tok}",
  "logs.tl.retry": "Retried",
  "logs.tl.more": "Show {n} more",
  "logs.tl.totals": "AI wait total {a} · action total {b} · time the chat was open {c}",
  "logs.tl.label": "Sequence",
  "logs.tl.dec": "{decision} · decided by: {actor}",
  "logs.tl.fail": "Failed",
  "logs.tl.axis": "Timeline",
  "logs.tl.axisView": "Timeline view",
  "logs.tl.axisAll": "All",
  "logs.tl.axisZoom": "Zoom in +",
  "logs.tl.rangeAll": "Whole conversation · {from}–{to}",
  "logs.tl.rangeTurn": "{turn} zoomed in · {from}–{to} · {d}",
  "logs.tl.fold": "≈ Breaks over 1 minute are folded",
  "logs.tl.pick": "Pick a range — then Zoom in + spreads out just that range",
  "logs.tl.lane.talk": "Q&A",
  "logs.tl.lane.call": "AI calls",
  "logs.tl.lane.work": "Actions",
  "logs.tl.zoomAria": "{turn} zoomed timeline · {from}–{to} · {meta} · {e|error|errors}",
  "logs.linked.subagents": "Sub-agents {n}",
  "logs.linked.helpers": "Helper requests {n}",
  "logs.linked.listTip": "Sub-agents and helper requests that ran inside this conversation. Their usage and actions are counted here.",
  "logs.linked.subagent": "Sub-agent",
  "logs.linked.helper": "Helper request",
  "logs.linked.helperName.title": "Task title",
  "logs.linked.actions": "{n} actions",
  "logs.linked.rows": "{n} rows",
  "logs.linked.tokens": "{n} tokens",
  "logs.linked.estimated": "Estimated link",
  "logs.linked.open": "Open separately (conversation #{no})",
  "logs.linked.request": "Request",
  "logs.linked.answer": "Answer",
  "logs.linked.empty": "Nothing to show.",
  "logs.linked.unavailable": "Could not load the content.",
  "logs.linked.actionsTitle": "Actions of sub-agents and helper requests",
  "logs.linked.parent.subagent": "This is a sub-agent that ran inside conversation #{no}",
  "logs.linked.parent.helper": "This is a helper request the CLI sent for conversation #{no}",
  "logs.linked.parent.open": "Open the conversation",
  "logs.linked.withSubagents": "{n} with sub-agents",
};

export default logs;
